(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mbc-shop"] && !Shopify.designMode) return;
  try {
    
/* MB collection template (mbc-*) picker logic, ported 1:1 from the mockup template.js.
   NO Liquid in this block: data comes from <script type="application/json" data-mbc-data>
   emitted by the mbc-shop section markup. Two modes:
   - "zodiac": sign chips + birth-date helper. Picking a sign swaps each card to its real
     variant photo (when the product has >= 12 distinct variant photos), deep-links the
     variant, and shows which version/stone the card now points at.
   - "intent": intention chips filter the grid.
   URL hash: #signe=lion, #intention=protection. */
(function () {
  function norm(s) {
    return String(s == null ? '' : s).normalize('NFKD').replace(/[^\x00-\x7f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function init() {
    var dataEl = document.querySelector('script[data-mbc-data]');
    if (!dataEl || dataEl.getAttribute('data-mbc-ready') === '1') return;
    dataEl.setAttribute('data-mbc-ready', '1');
    var D = JSON.parse(dataEl.textContent);
    var cards = Array.prototype.slice.call(document.querySelectorAll('.mbc-card'));
    var chips = Array.prototype.slice.call(document.querySelectorAll('.mbc-chip[data-key]'));
    var statusEl = document.querySelector('[data-mbc-status]');
    var resetBtn = document.querySelector('[data-mbc-reset]');
    var defaultStatus = statusEl ? statusEl.innerHTML : '';
    var state = { key: null, animal: null };

    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
    var GEM = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 4h10l4 5.5-9 10.5-9-10.5z"/><path d="M3 9.5h18M10 4 8.5 9.5 12 20M14 4l1.5 5.5L12 20"/></svg>';
    var curEl = document.querySelector('[data-mbc-cur]'), curDefault = curEl ? curEl.innerHTML : '';

    function press(key) {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-key') === key ? 'true' : 'false'); });
      if (resetBtn) resetBtn.hidden = !key;
      var on = key && chips.filter(function (c) { return c.getAttribute('data-key') === key; })[0];
      if (on) { var ul = on.closest('ul'); if (ul && ul.scrollWidth > ul.clientWidth) ul.scrollLeft = on.parentNode.offsetLeft - 16; }
    }

    /* ---------- zodiac ---------- */
    function signByKey(k) { for (var i = 0; i < D.signs.length; i++) if (D.signs[i].key === k) return D.signs[i]; return null; }
    function strip(k) { return k.replace(/[sx]+$/, ''); }
    function signKey(v) {
      var n = strip(norm(v));
      for (var i = 0; i < D.signs.length; i++) if (strip(D.signs[i].key) === n) return D.signs[i].key;
      return null;
    }

    /* port of build.py zodiac_products(): which option holds the 12 signs, per-sign variant id,
       variant photo only when the product has >= 12 distinct variant photos, pill text rules,
       Chinese-zodiac product keyed by animal. */
    function zodiacProducts(raw) {
      var out = {};
      Object.keys(raw || {}).forEach(function (h) {
        var p = raw[h], rec = {}, optIdx = null;
        (p.options || []).forEach(function (vals, i) {
          var n = 0; vals.forEach(function (v) { if (signKey(v)) n++; });
          if (n >= 12) optIdx = i;
        });
        if (h.indexOf('chinois') > -1) {
          var animals = {};
          p.variants.forEach(function (v) {
            var k = norm(v.o[0]);
            if (!(k in animals)) animals[k] = { v: v.id, label: v.o[0], img: v.img || null };
          });
          rec.animals = animals;
        } else if (optIdx !== null) {
          var seen = {}, distinct = 0;
          p.variants.forEach(function (v) { if (v.img && !seen[v.img]) { seen[v.img] = 1; distinct++; } });
          var perSign = distinct >= 12;
          var signs = {};
          var stoneMap = (D.stone && D.stone.handle === h) ? (D.stone.map || {}) : null;
          p.variants.forEach(function (v) {
            var k = signKey(v.o[optIdx]);
            if (!k || signs[k]) return;
            var lab = signByKey(k).label;
            var pill = 'Version ' + lab;
            if (stoneMap && stoneMap[k]) pill = (/^[AEIOUYÉ]/.test(lab) ? "Pierre de l'" : 'Pierre du ') + lab + ' : ' + stoneMap[k];
            signs[k] = { v: v.id, img: (perSign && v.img) ? v.img : null, pill: pill, stone: !!(stoneMap && stoneMap[k]) };
          });
          rec.signs = signs;
        }
        out[h] = rec;
      });
      return out;
    }
    if (D.mode === 'zodiac') D.products = zodiacProducts(D.raw);

    function applySign(key) {
      state.key = key;
      press(key);
      var s = key ? signByKey(key) : null;
      cards.forEach(function (card) {
        var h = card.getAttribute('data-handle');
        var p = D.products[h] || {};
        var img = card.querySelector('.mbc-card__media img');
        var a = card.querySelector('a');
        var pill = card.querySelector('.mbc-card__sign');
        var info = null, txt = '';
        if (key && p.signs && p.signs[key]) info = p.signs[key];
        if (key && p.animals) {
          if (state.animal && p.animals[state.animal]) { info = p.animals[state.animal]; txt = 'Votre animal : ' + info.label; }
          else txt = 'Signe chinois : selon votre année de naissance';
        } else if (info) {
          txt = info.pill || ('Version ' + s.label);
        }
        var src = (info && info.img) ? info.img : img.getAttribute('data-default');
        if (img.getAttribute('src') !== src) { img.style.opacity = '0'; img.onload = function () { img.style.opacity = '1'; }; img.removeAttribute('srcset'); img.setAttribute('src', src); }
        a.setAttribute('href', info && info.v ? (a.getAttribute('data-base') + '?variant=' + info.v) : a.getAttribute('data-base'));
        /* plain text tag (not a button): the stone line gets a small gem icon */
        var stoneLine = !!(info && info.stone && !(key && p.animals));
        pill.innerHTML = (stoneLine && txt ? GEM : '') + esc(txt);
        pill.classList.toggle('is-on', !!txt);
        pill.classList.toggle('is-stone', stoneLine && !!txt);
      });
      if (statusEl) {
        statusEl.innerHTML = s
          ? '<span>' + (s.glyph || '') + '<strong>' + esc(s.label) + '</strong> (' + esc(s.dates) + ') : les ' + cards.length + ' modèles existent pour ce signe. Les photos montrent maintenant la version ' + esc(s.label) + '.</span>'
          : defaultStatus;
      }
      if (curEl) curEl.innerHTML = s ? (s.glyph || '') + '<strong>' + esc(s.label) + '</strong>' : curDefault;
      setHash(key ? 'signe=' + key : '');
    }

    function signFromDate(day, month) {
      for (var i = 0; i < D.signs.length; i++) {
        var s = D.signs[i], f = s.from, t = s.to; // [month, day]
        if (f[0] === t[0]) { if (month === f[0] && day >= f[1] && day <= t[1]) return s; continue; }
        if ((month === f[0] && day >= f[1]) || (month === t[0] && day <= t[1])) return s;
      }
      return null;
    }

    function initHelper() {
      var form = document.querySelector('[data-mbc-helper]');
      if (!form) return;
      var dd = form.querySelector('[name=jour]'), mm = form.querySelector('[name=mois]'), yy = form.querySelector('[name=annee]');
      var out = form.querySelector('.mbc-helper__out');
      function run(go) {
        var d = parseInt(dd.value, 10), m = parseInt(mm.value, 10), y = parseInt(yy.value, 10);
        state.animal = null;
        var msg = '';
        if (y >= 1900 && y <= 2100) {
          var an = D.animals[((y - 4) % 12 + 12) % 12];
          state.animal = an.key;
          msg = ' Année ' + y + ' : ' + an.label + ' en astrologie chinoise' + (m && m <= 2 ? ' (né en janvier ou février : vérifiez la date du Nouvel An chinois de votre année).' : '.');
        }
        if (d && m) {
          var s = signFromDate(d, m);
          if (s) {
            applySign(s.key); out.textContent = 'Votre signe : ' + s.label + ' (' + s.dates + ').' + msg;
            if (go) { var g = document.getElementById('produits'); if (g) g.scrollIntoView({ behavior: smoothOk() ? 'smooth' : 'auto', block: 'start' }); }
            return;
          }
        }
        if (state.key) applySign(state.key);
        out.textContent = msg ? msg.trim() : '';
      }
      [dd, mm, yy].forEach(function (el) { el.addEventListener('change', function () { run(false); }); });
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (!dd.value || !mm.value) { out.textContent = 'Choisissez le jour et le mois de naissance.'; (dd.value ? mm : dd).focus(); return; }
        run(true);
      });
    }

    /* "Je ne connais pas le signe" reveals the birth-date finder (collapsed by default); the sticky bar's
       "Changer" scrolls back up to the sign chips */
    function initUnknown() {
      var btn = document.querySelector('[data-mbc-unknown]'), box = document.getElementById('trouver');
      var change = document.querySelector('[data-mbc-change]');
      function openF(open, focus) {
        if (!btn || !box) return;
        box.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && focus) { var f = document.getElementById('mbc-j'); if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }, 30); }
      }
      if (btn) btn.addEventListener('click', function () { openF(box.hidden, true); });
      if (change) change.addEventListener('click', function () {
        var t = document.getElementById('choisir'); if (!t) return;
        t.scrollIntoView({ behavior: smoothOk() ? 'smooth' : 'auto', block: 'start' });
        setTimeout(function () { var c = document.querySelector('.mbc-chip[aria-pressed="true"]') || document.querySelector('.mbc-chip'); if (c) { try { c.focus({ preventScroll: true }); } catch (e) { c.focus(); } } }, 450);
      });
      if (location.hash === '#trouver' && box) { openF(true, false); box.scrollIntoView({ block: 'start' }); }
    }

    /* ---------- intent ---------- */
    function applyIntent(key) {
      state.key = key;
      press(key);
      var n = 0;
      cards.forEach(function (card) {
        var list = (card.getAttribute('data-intents') || '').split(' ');
        var on = !key || list.indexOf(key) > -1;
        card.hidden = !on;
        if (on) n++;
      });
      if (statusEl) {
        if (!key) statusEl.innerHTML = defaultStatus;
        else {
          var it = D.intents[key];
          var html = '<span><strong>' + n + ' bracelet' + (n > 1 ? 's' : '') + '</strong> pour l’intention <strong>' + esc(it.label) + '</strong>.</span>';
          if (it.guide) html += '<a class="mbc-link" href="' + it.guide.href + '">' + esc(it.guide.label) + '</a>';
          statusEl.innerHTML = html;
        }
      }
      setHash(key ? 'intention=' + key : '');
    }

    /* ---------- shared ---------- */
    function setHash(h) {
      try { history.replaceState(null, '', h ? '#' + h : location.pathname + location.search); } catch (e) { }
    }
    var apply = D.mode === 'zodiac' ? applySign : applyIntent;
    function smoothOk() { return !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
    Array.prototype.forEach.call(document.querySelectorAll('[data-mbc-jump]'), function (btn) {
      btn.addEventListener('click', function (ev) {
        var t = document.querySelector(btn.getAttribute('href'));
        if (!t) return;
        ev.preventDefault();
        t.scrollIntoView({ behavior: smoothOk() ? 'smooth' : 'auto', block: 'start' });
        var f = document.querySelector(btn.getAttribute('data-mbc-jump'));
        if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }, 450);
      });
    });

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var k = c.getAttribute('data-key');
        apply(state.key === k ? null : k);
      });
    });
    if (resetBtn) resetBtn.addEventListener('click', function () { apply(null); });
    if (D.mode === 'zodiac') { initHelper(); initUnknown(); }

    var m = /(?:signe|intention)=([a-z-]+)/.exec(location.hash);
    if (m && chips.some(function (c) { return c.getAttribute('data-key') === m[1]; })) apply(m[1]);

    /* sticky bar shadow once it pins (IntersectionObserver on the sentinel, as in the mockup).
       Theme adaptation: the store header is itself sticky, so the bar pins right under it
       (--mbc-sticky-top) and the observer's top edge moves down by the same amount. */
    var bar = document.querySelector('.mbc-bar'), sentinel = document.querySelector('.mbc-bar-sentinel');
    var sbar = document.querySelector('[data-mbc-sbar]'), sbarBox = sbar ? sbar.nextElementSibling : null;
    var shop = document.querySelector('.mbc-shop');
    var io = null, curOff = -1, ioOff = -1, ticking = false, animating = false;
    /* visible part of the store's sticky header: the section wrapper stays pinned, the inner
       <header> slides out on scroll-down and back on scroll-up (Hyper "sticky on scroll up") */
    /* looked up on every sync: the theme only makes its header section sticky (class header-sticky)
       after its own JS runs, which can be after this init */
    function headerBottom() {
      var off = 0;
      Array.prototype.forEach.call(document.querySelectorAll('.shopify-section-group-header-group'), function (s) {
        var p = getComputedStyle(s).position;
        if (p !== 'sticky' && p !== 'fixed') return;
        var r = (s.querySelector('header') || s).getBoundingClientRect();
        if (r.top <= 1 && r.bottom > off) off = r.bottom;
      });
      return Math.max(0, Math.round(off));
    }
    function inHeader(t) { return t && t.closest && t.closest('.shopify-section-group-header-group'); }
    function sync(final) {
      ticking = false;
      if (!shop) return;
      var off = headerBottom();
      if (off !== curOff) { curOff = off; shop.style.setProperty('--mbc-sticky-top', off + 'px'); }
      /* zodiac: the compact bar is live only while the product list is under the header */
      if (sbar && sbarBox) { var w = sbarBox.getBoundingClientRect(); sbar.classList.toggle('is-live', w.top < off + 1 && w.bottom > off + 64); }
      if (!bar || !sentinel) return;
      if (final && off !== ioOff && 'IntersectionObserver' in window) {
        ioOff = off;
        if (io) io.disconnect();
        io = new IntersectionObserver(function (e) {
          var en = e[e.length - 1], edge = en.rootBounds ? en.rootBounds.top : off;
          /* stuck only when the sentinel has left through the top edge (bar pinned); a sentinel below
             the fold on load is also "not intersecting" and must not light the shadow */
          bar.classList.toggle('is-stuck', !en.isIntersecting && en.boundingClientRect.top < edge);
        }, { threshold: 0, rootMargin: (-off) + 'px 0px 0px 0px' });
        io.observe(sentinel);
      }
    }
    function loop() { sync(false); if (animating) requestAnimationFrame(loop); }
    document.addEventListener('transitionrun', function (e) { if (inHeader(e.target) && !animating) { animating = true; requestAnimationFrame(loop); } });
    ['transitionend', 'transitioncancel'].forEach(function (t) {
      document.addEventListener(t, function (e) { if (inHeader(e.target)) { animating = false; sync(true); } });
    });
    var trail = null;
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(function () { sync(true); }); }
      clearTimeout(trail); trail = setTimeout(function () { sync(true); }, 450);
    }
    sync(true);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();


  } catch(e) { console.error(e); }
})();
})();
